import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../../../ReducerRegister";
import { ActionTypes } from "../../../../actionTypes/screens/admin/promotion/management/EditActionTypes";
import EditService from "../../../../../services/screens/admin/promotion/management/EditService"
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.promotion.management.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (id) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    savePromotionAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.SAVE_PROMOTION_ASYNC, vo });
            
            EditService.savePromotion(vo,
                response => {
                    dispatch(Actions.savePromotionSuccess(response));
                },
                error => {
                    dispatch(Actions.savePromotionFailure(error));
                }
            );
        };
    },

    savePromotionSuccess: data => ({
        type: ActionTypes.SAVE_PROMOTION_SUCCESS,
        parentType: ActionTypes.SAVE_PROMOTION_ASYNC,
        postReducer: savePromotionSuccessPostReducer,
        data
    }),

    savePromotionFailure: error => ({
        type: ActionTypes.SAVE_PROMOTION_FAILURE,
        parentType: ActionTypes.SAVE_PROMOTION_ASYNC,
        error
    }),

    uploadAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPLOAD_ASYNC, vo });

            EditService.upload(
                vo,
                response => {
                    dispatch(Actions.uploadSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.uploadFailure(error));
                }
            );
        };
    },

    uploadSuccess: (data, vo) => ({
        type: ActionTypes.UPLOAD_SUCCESS,
        parentType: ActionTypes.UPLOAD_ASYNC,
        postReducer: uploadSuccessPostReducer,
        data,
        vo
    }),

    uploadFailure: error => ({
        type: ActionTypes.UPLOAD_FAILURE,
        parentType: ActionTypes.UPLOAD_ASYNC,
        error
    }),

    remove: vo => ({
        type: ActionTypes.REMOVE,
        vo
    }),

    createPromotion: () => ({
        type: ActionTypes.CREATE_PROMOTION
    })
};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    promotionInfo: null,
    banners: {
        th: [],
        en: [],
        ko: [],
        zh: [],
    },
};

/* ------------- Reducers ------------- */
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, promotionInfo: data.promotionInfo, banners: data.promotionInfo.banners};
};

const savePromotionSuccessPostReducer = (state, { data }) => {
    return { ...state, };
};

const createPromotionReducer = (state) => {
    return { ...state, promotionInfo: {}, banners: { th: [], en: [], ko: [], zh: [] } };
};

const uploadSuccessPostReducer = (state, { data, vo }) => {
    const { virtualPath: filePath } = data;
    let newBanners = _.clone(state.banners);
    let languageImg = vo.languageImg;
    if(languageImg === "en"){
        newBanners.en.push(filePath)
    }else if(languageImg === "th"){
        newBanners.th.push(filePath)
    }else if(languageImg === "ko"){
        newBanners.ko.push(filePath)
    }else{
        newBanners.zh.push(filePath)
    }

    return { ...state, banners: newBanners };
};

const removeReducer = (state, { vo }) => {
    let newBanners = _.clone(state.banners);
    if (vo.languageImg === "zh") {
        newBanners.zh.splice(vo.index, 1);
    } else if(vo.languageImg === "en"){
        newBanners.en.splice(vo.index, 1);
    } else if(vo.languageImg === "th"){
        newBanners.th.splice(vo.index, 1);
    } else if(vo.languageImg === "ko"){
        newBanners.ko.splice(vo.index, 1);
    }
    return { ...state, banners: newBanners };
};

/* ------------- Hookup Reducers To Types ------------- */

const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_PROMOTION_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_PROMOTION_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_PROMOTION_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPLOAD_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPLOAD_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPLOAD_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE]: removeReducer,
    [ActionTypes.CREATE_PROMOTION]: createPromotionReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };